
<div class="card cp" [ngClass]="[(showOnlyVacant && !employee?.isVacant) ? 'blur' : '', employee?.isVacant && !showOnlyVacant ? 'blur' : '', employee?.isVacant && showOnlyVacant ? '' : '']">
  
  <div class="verticle-center">
    <div class="org-emp-initials color-box" [ngClass]="(employee?.department !== selectDepartment && selectDepartment) ? 'hidden' : ''">{{getInitials(employee?.name)}}</div>
    <div [ngClass]="(employee?.department !== selectDepartment && selectDepartment) ? 'hidden' : ''">
      <h4 class="org-emp-name fs-13 fs_12ForMobile phi-fw-600 ml-15" *ngIf="!employee?.isVacant">{{employee?.name}}</h4>
      <p class="org-emp-depertment fs-11 fs_10ForMobile ml-15 mt-5">{{employee?.designation}} - {{employee?.department}}</p>
    </div>
  </div>
  
  <div *ngIf="employee?.noOfIndirectReportees > 0" class="plus-box cp" (click)="toggleChildren(employee)" [ngClass]="(employee?.department !== selectDepartment && selectDepartment) ? 'hidden-plus-box' : ''">
    <div class="text-center">
      <div class="orgCardEmployeeCount">{{employee?.noOfIndirectReportees}}</div>
      <div style="margin-top: -5px;">{{ !employee?.showChildren ? '+' : '-'}}</div>
    </div>
  </div>
  
  <div class="popup" [ngClass]="(employee?.department !== selectDepartment && selectDepartment) ? 'hidden-popup' : ''">
    <div class="flex-container">
      <div class="half">
        <p class="fs-10 phi-cl-5c5555">Band</p>
        <p class="fs-14 fs_12ForMobile phi-fw-600 mt-5">{{employee?.band}}</p>
      </div>
      <div class="half" *ngIf="!employee?.isVacant">
        <p class="fs-10 phi-cl-5c5555">PMS YTD Score</p>
        <p class="fs-14 fs_12ForMobile phi-fw-600 mt-5">{{toNumber(employee?.pmsYtd) | number:'1.2-2'}}</p>
      </div>
      <div class="half">
        <p class="fs-10 phi-cl-5c5555">Grade</p>
        <p class="fs-14 fs_12ForMobile phi-fw-600 mt-5">{{employee?.grade}}</p>
      </div>
      <div class="half" *ngIf="!employee?.isVacant">
        <p class="fs-10 phi-cl-5c5555">Competency Score(rating)</p>
        <p class="fs-14 fs_12ForMobile phi-fw-600 mt-5">{{employee?.competencyScore}}</p>
      </div>
      <div class="half">
        <p class="fs-10 phi-cl-5c5555">No of direct reportees</p>
        <p class="fs-14 fs_12ForMobile phi-fw-600 mt-5">{{employee?.noOfDirectReportees}}</p>
      </div>
      <div class="half">
        <p class="fs-10 phi-cl-5c5555">No of indirect reportees</p>
        <p class="fs-14 fs_12ForMobile phi-fw-600 mt-5">{{employee?.noOfIndirectReportees}}</p>
      </div>
      <div class="half" *ngIf="!employee?.isVacant">
        <p class="fs-10 phi-cl-5c5555">DOJ</p>
        <p class="fs-14 fs_12ForMobile phi-fw-600 mt-5">{{employee?.doj | date:'dd/MM/yyyy'}}</p>
      </div>
    </div>
  </div>
</div>

<ul *ngIf="employee?.showChildren && employee?.subordinates?.length > 0" [ngClass]="{'no-line': employee?.department !== selectDepartment && selectDepartment}">
  <ng-container *ngFor="let sub of employee?.subordinates">
    <li app-org-subordinates [ngClass]="{'no-line': sub?.department !== selectDepartment && selectDepartment}" [employee]="sub" [selectDepartment]="selectDepartment" [showOnlyVacant]="showOnlyVacant"></li>
  </ng-container>
</ul>